import React from 'react';
import { Col } from 'react-bootstrap';

import useCompanySetting from 'App/hooks/useCompanySetting';
import { TextField } from 'Shared/form/TextField';
import CommonPatientFieldWrapper from '../CommonPatientFieldWrapper';

const EhrIdTypeField = () => {
    const { data: ehrPrimaryIdType } = useCompanySetting('ehrPrimaryIdType', { defaultValue: '' });

    return (
        <CommonPatientFieldWrapper fieldName="ehrPrimaryIdType">
            {(commonProps) => (
                <Col md={3}>
                    {ehrPrimaryIdType && (
                        <TextField
                            fieldName={commonProps.fieldName}
                            label="EHR ID Type"
                            placeholder="EHR ID Type"
                            disabled
                            value={ehrPrimaryIdType}
                        />
                    )}
                </Col>
            )}
        </CommonPatientFieldWrapper>
    );
};

export default EhrIdTypeField;
